import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';

import Button from 'components/CncUI/Button';
import Modal from 'components/CncUI/Modal';

const useStyles = makeStyles(({ palette }) => ({
  root: {
    '& .MuiDialog-paper': {
      width: 500,
      margin: 14,
    },
  },
  link: {
    color: palette.cncUI.misc.link,
    textDecoration: 'none',
  },
}));

const TermAndConditions = props => {
  const classes = useStyles();
  const { show, onClose } = props;
  const [declined, setDeclined] = useState(false);

  const content = declined ? (
    <Modal.ContentText id="TermsAndConditionsMessage">
      You have selected to decline the terms of use for MyCast&Crew. Please
      select continue to be redirected to the Cast & Crew homepage.
    </Modal.ContentText>
  ) : (
    <Modal.ContentText id="TermsAndConditionsMessage">
      I have read and agree to the Cast & Crew{' '}
      <Link
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.castandcrew.com/terms-of-use/"
        id="TermsAndConditionsTermsOfUseLink"
        className={classes.link}
      >
        Terms of Use
      </Link>{' '}
      and{' '}
      <Link
        href="https://www.castandcrew.com/privacy-policy/"
        target="_blank"
        rel="noopener noreferrer"
        id="TermsAndConditionsPrivacyPolicyLink"
        className={classes.link}
      >
        Privacy Policy
      </Link>
      . I consent to transacting electronically with Cast & Crew and using my
      electronic signature.
      <br />
      <br />
      For assistance, please email Employee Help Desk at
      <br />
      <Link
        href="mailto:employeehelpdesk@castandcrew.com"
        target="_blank"
        rel="noopener noreferrer"
        id="TermsAndConditionsEmailHelpDeskLink"
        className={classes.link}
      >
        employeehelpdesk@castandcrew.com
      </Link>{' '}
      or call{' '}
      <Link
        href="tel:8885704650"
        target="_blank"
        rel="noopener noreferrer"
        id="TermsAndConditionsPhoneHelpDeskLink"
        className={classes.link}
      >
        888.570.4650
      </Link>
      .
      <br />
      For Media Services assistance, email
      <br />
      <Link
        href="mailto:crewportalhelp@mediaservices.com"
        target="_blank"
        rel="noopener noreferrer"
        id="TermsAndConditionsEmailMediaServicesLink"
        className={classes.link}
      >
        crewportalhelp@mediaservices.com
      </Link>{' '}
      or call{' '}
      <Link
        href="tel:3102541702"
        target="_blank"
        rel="noopener noreferrer"
        id="TermsAndConditionsPhoneMediaServicesLink"
        className={classes.link}
      >
        310.254.1702
      </Link>
      .
    </Modal.ContentText>
  );

  return (
    <Modal
      open={show}
      id="TermsAndConditions"
      disableBackdropClick
      disableEscapeKeyDown
      className={classes.root}
    >
      <Modal.Title id="TermsAndConditionsTitle">
        Terms and Conditions
      </Modal.Title>
      <Modal.Content>{content}</Modal.Content>
      <Modal.Actions>
        {declined ? (
          <Button
            onClick={() =>
              (window.location.href = 'https://www.castandcrew.com')
            }
            className={classes.button}
            id="TermsAndConditionsContinueButton"
          >
            Continue
          </Button>
        ) : (
          <>
            <Button
              secondary
              onClick={() => setDeclined(true)}
              className={classes.button}
              id="TermsAndConditionsDeclineButton"
            >
              Decline
            </Button>
            <Button
              onClick={onClose}
              className={classes.button}
              id="TermsAndConditionsAcceptButton"
            >
              I Agree
            </Button>
          </>
        )}
      </Modal.Actions>
    </Modal>
  );
};

export default TermAndConditions;
